module.exports = __webpack_public_path__ + "static/Roostr2-6d38ffc828de02b6a8f69fa3146eeda9.png";